export enum Browser {
  Chrome = 'Google Chrome',
  Edge = 'Microsoft Edge',
  Firefox = 'Mozilla Firefox',
  Safari = 'Safari',
  Unknown = 'Unknown Browser'
}
